import { gql } from '@apollo/client';

export const FEED_QUERY = gql`
  query Feed($limit: Int, $after: String, $bucket: String) {
    feed(limit: $limit, after: $after, bucket: $bucket) {
      items {
        id title url authorId score commentCount createdAt
      }
      nextToken
    }
  }
`;

export const POST_QUERY = gql`
  query Post($id: ID!) {
    post(id: $id) {
      id title url text authorId score commentCount createdAt
    }
    comments(postId: $id) {
      id postId parentId body authorId createdAt
    }
  }
`;

export const ME_QUERY = gql`
  query Me { me { id username karma bio } }
`;

export const SUBMIT_POST = gql`
  mutation SubmitPost($input: SubmitPostInput!) {
    submitPost(input: $input) { id title }
  }
`;

export const ADD_COMMENT = gql`
  mutation AddComment($input: AddCommentInput!) {
    addComment(input: $input) {
      id postId parentId body authorId createdAt
    }
  }
`;

export const VOTE = gql`
  mutation Vote($targetType: VoteTarget!, $targetId: ID!) {
    vote(targetType: $targetType, targetId: $targetId)
  }
`;

export const COMMENT_ADDED = gql`
  subscription OnCommentAdded($postId: ID!) {
    onCommentAdded(postId: $postId) {
      id postId parentId body authorId createdAt
    }
  }
`;
